const KnowledgeBaseSupportAccordian = ({ data }) => {
  return (
    <div className="px-2 py-2" id={data.id} style={{ scrollMarginTop: "5rem" }}>
      <div className="flex space-x-2 cursor-pointer pb-2 border-b-2 border-[#E2F4F4]">
        <h4 className="">{data.title}</h4>
      </div>
      <p className="mt-2 p-1 text-red-600 font-bold">
        {data.message !== "" && "Message:   "}
        {data.message}
      </p>
      {data.text !== "" && (
        <ol className="light-paragraph-open-sans">
          <li>
            {data.text
              .split(/(".*?")/)
              .map((part, index) =>
                part.startsWith('"') && part.endsWith('"') ? (
                  <strong key={index}>{part.slice(1, -1)}</strong>
                ) : (
                  part
                )
              )}
          </li>
        </ol>
      )}
      {data.list !== undefined && (
        <ul className="light-paragraph-open-sans">
          {data.list.map((x, y) => {
            return (
              <li>
                <span className="text-[#259f9b]">{"●  "}</span>
                {x
                  .split(/(".*?")/)
                  .map((part, index) =>
                    part.startsWith('"') && part.endsWith('"') ? (
                      <strong key={index}>{part.slice(1, -1)}</strong>
                    ) : (
                      part
                    )
                  )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
export default KnowledgeBaseSupportAccordian;
